const getPercentage = (val, dividend) => {
    return (val / dividend) * 100
  }
  
  export default getPercentage